// extracted by mini-css-extract-plugin
export default {"infoBox":"infoBox---wYAlB","error":"error---S9jB9","warn":"warn---hxj9y","success":"success---MOQ_y","default":"default---IHbip"};